export const formCalTotal = () => {
    function setCalTotalAll() {
        var orikmiPrice = Number($('.js-orikomi-price-data').val());
        var insatsuPrice = Number($('.js-insatsu-price-data').val());
        var designPrice = Number($('.js-design-price-data').val());
        var money = Number($('.js-money-data').val());
        var bannerPrice = Number($('.js-banner-data').val());
        $('.js-cal-todal').html((orikmiPrice + insatsuPrice + designPrice + money + bannerPrice).toLocaleString() + '円');
        $('.js-set-cal-total').val(orikmiPrice + insatsuPrice + designPrice + money + bannerPrice);
    }
    setCalTotalAll();

    window.setCalTotalAll = setCalTotalAll;
}

